import React, { Component } from "react";
import { Alert, Row, Col, Button, FormGroup, Label, Input, Spinner } from 'reactstrap';
import axios from '../../utils/request';
import Select from 'react-select';
import './CqtjCss.css';
//import './styles.css';
export class Cqtj_OfferApply extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            loading: true,
            code: "",
            tenantId: - 1,
            showError: false,
            showErrorMsg: "",
            commonParamater: "",
            applicant: {
                "profile": { "name": "", "Gender": "", "Birthday": "", "nativePlace": "", "age": "", "birthday": "", "belongSource": "", "ResumeLink": "","showLink":""},
                "job": { "Name": "", "departmentDescription": "", "jobTitle": "" },
                "user": [{ "name": "", "email": "", "Mobile": "", "Mobile": "", "Mobile": "" }],
                "choosenSalaryExecutive": "",
                "applyId": ""
            },
            users: [],
            selectedOption: null,
            selectedOptionBlank: "none",
            applicantBackup: {},
            departmentDescriptionBlank: "none",
            departmentDescription: null,
            jobTitleBlank: "none",
            jobTitle: null
        }
    };

    componentDidMount() {
        this.setState({ code: "201", loading: true });
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        if (!commonParamater) {
            this.setState({ code: "500", message: "参数异常，请联系管理员。", loading: false });
            return;
        }
        this.setState({ tenantId: tenantId, commonParamater: commonParamater });

        const param = {
            tenantId,
            commonParamater
        };
        axios.get(
            "/api/Cqtj/GetApplicantInfo", { params: param }
        )
            .then(res => {
                const codeValue = res.data.code;
                let msg = "";
                if (codeValue === "500") {

                    this.setState({ code: codeValue, message: res.data.message, loading: false });
                } else {
                    this.setState({ users: res.data.data.user, })
                    this.setState({ code: "100", message: "", loading: false, applicant: res.data.data, applicantBackup: res.data.data })
                }
            })
            .catch(reason => {
                this.setState({ code: "500", message: "发起失败，请稍后再试！", loading: false })
            });


    };

    showError = (text) => {
        this.setState({ showErrorMsg: text, showError: true })
    }

    errDismiss = () => {
        const isErrorShowing = this.state.showError;
        if (isErrorShowing) {
            this.setState({ showError: false })
        }
        else {
            this.setState({ showError: true })
        }
    };

    ResetFun = () => {
        this.setState({ code: "201", loading: true });
        const applicant = this.state.applicant;
        applicant.job.departmentDescription = "";
        applicant.job.jobTitle = "";
        this.setState({ code: "100", message: "", loading: false, applicant: applicant, selectedOption: null });
    };

    handleChange = selectedOption => {
        this.setState({ selectedOption });
        // Option selected: { value: "chocolate", label: "Chocolate" }
        console.log(`Option selected:`, selectedOption);
    };
    submitFun = () => {
        if (this.state.applicant.job.departmentDescription == "" || this.state.applicant.job.departmentDescription == null || this.state.applicant.job.departmentDescription == undefined) {
            this.setState({ departmentDescriptionBlank: "block" });
            return false;
        } else {
            this.setState({ departmentDescriptionBlank: "none" });
        }
        if (this.state.applicant.job.jobTitle == "" || this.state.applicant.job.jobTitle == null || this.state.applicant.job.jobTitle == undefined) {
            this.setState({ jobTitleBlank: "block" });
            return false;
        } else {
            this.setState({ jobTitleBlank: "none" });
        }
        if (this.state.selectedOption == "" || this.state.selectedOption == null || this.state.selectedOption == undefined) {
            this.setState({ selectedOptionBlank: "block" });
            return false;
        } else {
            this.setState({ selectedOptionBlank: "none" });
        }
        this.setState({ code: "201", loading: true });
        const urlParams = new URLSearchParams(window.location.search);
        const tenantId = urlParams.get("tenantId");
        const applicant = this.state.applicant;

        applicant.choosenSalaryExecutive = this.state.selectedOption.email;

        const param = {
            tenantId,
            applicant
        };
        const bodyString = JSON.stringify(param);
        axios.post("/api/Cqtj/Submit", bodyString,
            {
                headers: { "Content-Type": "application/json" }
            }
        )
            .then(res => {
                const codeValue = res.data.code;
                let msg = "";
                if (codeValue === "500") {

                    this.setState({ code: codeValue, message: res.data.message, loading: false });
                } else {
                    this.setState({ code: "200", message: "", loading: false })
                }
            })
            .catch(reason => {
                alert(reason);
                this.setState({ code: "500", message: "发起失败，请稍后再试！", loading: false })
            });
    };

    //renderHtml2 = () => renderHtml = () => {
    //    return (
    //        <Col sm="12" md={{ size: 8, offset: 2 }} style={{ marginTop: '50px' }}>
    //        </Col>
    //    )
    //}
    renderHtml = () => {
        return (
            <Col className={"cqtjWrapper"} sm="12" md={{ size: 12 }} style={{ marginTop: '50px' }}>
                <Alert color="light">
                    <div class="panel-heading" style={{ marginLeft: "auto", textAlign: "center" }}>员工录用审批表</div>
                    <table border="1" cellspacing="0" class="form-table">
                        <tbody>
                            <tr>
                                <td colspan="4">
                                    <div class="form-group">
                                        <label><b>候选人简历及面试评价：</b></label>
                                        <a href={this.state.applicant.profile.showLink} target="_blank" rel="noreferrer">点击查看（简历详情链接）</a>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="form-group">
                                        <label><b>姓名：</b></label> {this.state.applicant.profile.name}
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group">
                                        <label><b>性别：</b></label> {this.state.applicant.profile.gender}
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group">
                                        <label><b>年龄：</b></label> {this.state.applicant.profile.age}
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group">
                                        <label><b>籍贯：</b></label> {this.state.applicant.profile.nativePlace}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="form-group">
                                        <label><b>信息来源：</b></label> {this.state.applicant.profile.belongSource}
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group">
                                        <label><b>拟入职部门：</b></label>
                                        {/*<input class="form-control" value={this.state.applicant.job.departmentDescription} type="text"*/}
                                        {/*    id="extnrzbm_109847_1278621018" placeholder="请输入" autocomplete="off" />*/}

                                        <Input maxLength="500" defaultValue={this.state.applicant.job.departmentDescription} value={this.state.applicant.job.departmentDescription}
                                            onChange={(event) => {
                                                const applicant = this.state.applicant;
                                                applicant.job.departmentDescription = event.target.value
                                                this.setState({
                                                    applicant: applicant,
                                                    departmentDescriptionBlank: "none"
                                                })
                                            }}
                                            placeholder="请输入" autocomplete="off"></Input>
                                        <div id="divAlertJobDepartment" class="alert bg-danger" role="alert" style={{ display: this.state.departmentDescriptionBlank }}>
                                            <em class="fa fa-lg fa-warning">&nbsp;</em>拟入职部门不能为空
                                        </div>
                                    </div>
                                </td>
                                <td colspan="2">
                                    <div class="form-group">
                                        <label><b>岗位名称：</b></label>
                                        <Input maxLength="500" defaultValue={this.state.applicant.job.jobTitle} value={this.state.applicant.job.jobTitle}
                                            onChange={(event) => {
                                                const applicant = this.state.applicant;
                                                applicant.job.jobTitle = event.target.value
                                                this.setState({
                                                    applicant: applicant,
                                                    jobTitleBlank: "none"
                                                })
                                            }}
                                            placeholder="请输入" autocomplete="off"></Input>
                                        {/*<input class="form-control" value={this.state.applicant.job.jobTitle} type="text" id="extnrzgw_109847_477261962" placeholder="请输入" autocomplete="off" />*/}
                                        <div id="divAlertJobTitle" class="alert bg-danger" role="alert" style={{ display: this.state.jobTitleBlank }}>
                                            <em class="fa fa-lg fa-warning">&nbsp;</em>岗位名称不能为空
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="4" align="left">
                                    <div class="form-group" style={{ marginLeft: "15px" }}>
                                        <label><b>薪资专员：</b></label>
                                        <Select
                                            value={this.state.selectedOption}
                                            onChange={this.handleChange}
                                            options={this.state.applicant.user}
                                        />
                                        <div id="divAlertSalaryExecutive" class="alert bg-danger" role="alert" style={{ display: this.state.selectedOptionBlank }}>
                                            <em class="fa fa-lg fa-warning">&nbsp;</em>请选择薪资专员
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <hr />
                    <Button type="primary" onClick={this.submitFun} className={"btn-primary"} style={{ marginRight: "10px", float: "right" }}>立即提交</Button>
                    <Button type="primary" onClick={this.ResetFun} className={"btn-default"} style={{ marginRight: "10px", float: "right" }}>重置</Button>
                </Alert>
            </Col >
        );
    }

    renderSendedHtml = () => {
        return (
            <Col sm="12" md={{ size: 8, offset: 2 }} style={{ marginTop: '50px' }}>
                <Alert color="light">
                    <h4 className="alert-heading">提交成功</h4>
                    <hr />
                </Alert>
            </Col>
        );
    }

    renderSendingHtml = () => {
        return (
            <Col sm="12" md={{ size: 8, offset: 2 }} style={{ marginTop: '50px' }}>
                <Alert color="light">
                    <h4 className="alert-heading">发送中</h4>
                    <hr />
                </Alert>
            </Col>
        );
    }

    render() {
        let contents = ""
        if (this.state.loading) {
            contents = ""
            contents = <div style={{ textAlign: "center", padding: "15px" }}>
                <Spinner type="grow" color="primary" />
                <Spinner type="grow" color="secondary" />
                <Spinner type="grow" color="success" />
                <Spinner type="grow" color="danger" />
                <Spinner type="grow" color="warning" />
                <Spinner type="grow" color="info" />
                <Spinner type="grow" color="light" />
                <Spinner type="grow" color="dark" />
            </div>
        } else {
            contents = ""

            if (this.state.code === "100") {
                contents = this.renderHtml()
            } else if (this.state.code === "201") {
                contents = this.renderSendingHtml()
            } else if (this.state.code === "200") {
                contents = this.renderSendedHtml()
            } else {
                contents = <p><em>Error...</em> | Code = {this.state.code} | Message = {this.state.message}</p>
            }
        }

        return (
            <div>{contents}</div>
        );
    }
}